var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerWrappedWithEggInCornSyrup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5792 11.6781C75.1255 12.5061 74.0541 12.9312 73.0457 12.6851L71.7097 12.3494C67.974 13.8004 67.1126 15.1525 67 19.5V80.3538C67 82.4461 65.4173 84 63.0603 84H15.5059C13.1363 84 11 82.4461 11 80.3538L10.6415 8.21071C10.6415 6.68907 10.1121 5.33419 9.15416 4.05869C8.64999 3.09648 9.44406 2 10.6415 2H60.4288C65.8108 2 70.9534 3.958 74.6591 7.40407C76.0078 8.48936 76.3859 10.2348 75.5792 11.6781Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 54L61.0197 53.9771C63.2153 53.9771 65 52.8182 65 51.3923V38.2222C46.1083 37.7952 36.1218 36 12 36L12 51.4076C12 52.841 13.7847 54 15.992 54Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41.4V78.8492C12 80.5965 13.7831 82.0092 15.9885 82L60.9763 81.9721C63.17 81.9721 65 80.498 65 78.76V37.08C65 36.764 64.9765 36.316 65 36C46.4887 36.1394 37.8205 41.4 12 41.4Z",
    fill: "#66CEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 33L61.0197 32.9771C63.2153 32.9771 65 31.8182 65 30.3923V17.2222C46.1083 16.7952 36.1218 15 12 15L12 30.4076C12 31.841 13.7847 33 15.992 33Z",
    fill: "#33BEF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.4V57.8492C12 59.5965 13.7831 61.0092 15.9885 61L60.9763 60.9721C63.17 60.9721 65 59.498 65 57.76V16.08C65 15.764 64.9765 15.316 65 15C46.4887 15.1394 37.8205 20.4 12 20.4Z",
    fill: "#66CEF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7832 68.6822C48.318 66.2915 45.4241 63.5587 44 61.5C42.6165 59.5 43 56.5945 38.8893 56.5945C37.1948 56.5945 35.4846 58.7401 33.5 61C31.3539 63.4438 28.9953 66.106 28.9954 68.6822C28.9954 73.6407 31.5147 79.2083 38.8893 79.2083C46.264 79.2083 49.8826 74.5663 48.7832 68.6822Z",
    fill: "url(#paint0_radial_10219_28064)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0272 69.5C46.0272 73.833 43.4488 78.3455 39.0346 78.3455C34.6204 78.3455 32.042 73.833 32.042 69.5C32.042 65.167 34.6204 60.6179 39.0346 60.6179C41.5 60.6179 46.0272 65.167 46.0272 69.5Z",
    fill: "url(#paint1_radial_10219_28064)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9C15 8.44772 15.4477 8 16 8H25C25.5523 8 26 8.44772 26 9C26 9.55228 25.5523 10 25 10H17V22H25C25.5523 22 26 22.4477 26 23C26 23.5523 25.5523 24 25 24H17V36H25C25.5523 36 26 36.4477 26 37C26 37.5523 25.5523 38 25 38H17V50H25C25.5523 50 26 50.4477 26 51C26 51.5523 25.5523 52 25 52H17V64H25C25.5523 64 26 64.4477 26 65C26 65.5523 25.5523 66 25 66H17V78H25C25.5523 78 26 78.4477 26 79C26 79.5523 25.5523 80 25 80H16C15.4477 80 15 79.5523 15 79V65V51V37V23V9Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 18,
    width: 60,
    height: 2,
    fill: "#ED3431"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04086 2.43386C5.7633 1.18483 6.71374 0 7.99323 0H61.0049C66.4104 0 71.5601 2.30246 75.1645 6.3309L75.8983 7.15106C77.0419 8.42916 76.8832 10.4041 75.5502 11.4832L67.5 18H9.5L6.04086 2.43386Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30L9.5 20.5L10 20H67.5L75 30L72 29.5L67 31.1667C68 32.5 65.6 33.6667 64 35.6667C62.4 37.6667 54 38.5 50 36L43.6875 34C44.5208 35.3333 41.6 37.1 36 37.5C33.4028 37.6855 31.3466 37.2329 28.5 36.5611C25 35.7352 24.6755 32.6451 24 32L20.5 34L16.5 30L14 34L0 30Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 30L19.5 20L14 33.5L17 30Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32L20.5 34L24.5 20L24 32Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 20L50 36L44 34L42.5 20Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 20L67 31L71.5 29.5L65 20Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3L26 18L28.5 3H24.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3L14 18L12 3H10Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 5L61.5 18L73 8.5L69.5 5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 2L54.5 18L58 2H53.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 2L54.5 18L60.5 2H58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0001 37.0001L42.5001 20.0001C49.1668 25.6667 60.0001 37.5001 60.0001 37.5001C58.0001 37.9001 54.5001 37.3334 53.0001 37.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 6.00006C33.2001 6.80007 36.6668 14.0001 39.0001 17.5001C38.8334 17.6667 38.3001 17.8 37.5001 17.0001C36.5001 16.0001 33.5001 7.00006 34.0001 3.50006C34.5001 6.29425e-05 43.5001 3.00004 46.5001 2.00004C49.5001 1.00004 51.5001 6.50004 50.5001 9.50007C49.7001 11.9001 44.8334 16.1667 42.5001 18C43.1668 16.6667 44.7001 13.1001 45.5001 9.50007C46.5001 5.00007 44.0001 5.00006 38.0001 6.00006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 32C39.8382 31.479 36.503 23.9477 34.376 20.3186C34.552 20.1618 35.0921 20.0596 35.8445 20.9045C36.785 21.9606 41.7016 30.8936 40.9999 34.3588C40.2983 37.824 31.4241 36 29.9919 34.3588C27.9127 31.9762 25.2606 29.5771 26.4325 26.64C27.37 24.2902 30.4753 22.3123 32.9108 20.617C32.1681 21.9095 32.2994 23.7632 29.9919 26.64C28.5 28.5 28.9522 32.6513 35 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4999 33.0001C55.4999 31.4001 52.6666 24.0001 51.4999 20.5001C54.9999 24.0001 62.1999 30.7001 62.9999 29.5001C63.7999 28.3001 60.9999 22.6667 59.4999 20.0001C61.1665 22.5001 64.6999 27.7001 65.4999 28.5001C66.2999 29.3001 66.9999 30.5001 66.9999 32.0001C66.4999 33.0001 64.2999 34.6001 63.4999 35.0001C62.4999 35.5001 59.9999 35.0001 57.4999 33.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3H23.5L24.5 18L20 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3H16L15 18L12.5 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 32.5L15 20.5L2.5 30.5L8.5 32.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10219_28064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8892 69.4014) rotate(90) scale(9.8069 10.0876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECB1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10219_28064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0001 70) rotate(180) scale(7 8.72854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerWrappedWithEggInCornSyrup);
export default __webpack_public_path__ + "static/media/beaker_wrapped_with_egg_in_corn_syrup.38e761f00ee05cf3b5e3ab59358c76d3.svg";
export { ForwardRef as ReactComponent };